var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "page-title pull-left" }, [
      _c("h2", { staticClass: "entry-title" }, [
        _vm.getPathName("services")
          ? _c("div", [
              _vm._v(_vm._s(_vm.services[_vm.getCurrentLocale])),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "1.0rem", "font-weight": "600" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getSharedAgencyLoginResultsAgencyObject !== null
                        ? " - " +
                            JSON.parse(
                              _vm.getSharedAgencyLoginResultsAgencyObject
                            ).companyName
                        : ""
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("booking")
          ? _c("div", [
              _vm._v(_vm._s(_vm.booking[_vm.getCurrentLocale])),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "1.0rem", "font-weight": "600" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getSharedAgencyLoginResultsAgencyObject !== null
                        ? " - " +
                            JSON.parse(
                              _vm.getSharedAgencyLoginResultsAgencyObject
                            ).companyName
                        : ""
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("flighttransfer")
          ? _c("div", [
              _vm._v(_vm._s(_vm.flighttransfer[_vm.getCurrentLocale])),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "1.0rem", "font-weight": "600" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getSharedAgencyLoginResultsAgencyObject !== null
                        ? " - " +
                            JSON.parse(
                              _vm.getSharedAgencyLoginResultsAgencyObject
                            ).companyName
                        : ""
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("addinfant")
          ? _c("div", [
              _vm._v(_vm._s(_vm.addinfant[_vm.getCurrentLocale])),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "1.0rem", "font-weight": "600" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getSharedAgencyLoginResultsAgencyObject !== null
                        ? " - " +
                            JSON.parse(
                              _vm.getSharedAgencyLoginResultsAgencyObject
                            ).companyName
                        : ""
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("rebooking")
          ? _c("div", [
              _vm._v(_vm._s(_vm.rebooking[_vm.getCurrentLocale])),
              _c(
                "span",
                {
                  staticStyle: { "font-size": "1.0rem", "font-weight": "600" },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getSharedAgencyLoginResultsAgencyObject !== null
                        ? " - " +
                            JSON.parse(
                              _vm.getSharedAgencyLoginResultsAgencyObject
                            ).companyName
                        : ""
                    )
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("ul", { staticClass: "breadcrumbs pull-right" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("li", { staticClass: "active" }, [
        _vm.getPathName("services")
          ? _c("span", [_vm._v(_vm._s(_vm.services[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("booking")
          ? _c("span", [_vm._v(_vm._s(_vm.booking[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("flighttransfer")
          ? _c("span", [
              _vm._v(_vm._s(_vm.flighttransfer[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("addinfant")
          ? _c("span", [_vm._v(_vm._s(_vm.addinfant[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("rebooking")
          ? _c("span", [_vm._v(_vm._s(_vm.rebooking[_vm.getCurrentLocale]))])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "pull-right",
        staticStyle: { "margin-left": "20px", "margin-top": "14px" },
      },
      [
        _c(
          "a",
          {
            staticClass: "animated",
            attrs: {
              id: "back-to-bottom",
              href: "#",
              "data-animation-type": "bounce",
            },
          },
          [
            _c("i", {
              staticClass: "soap-icon-longarrow-bottom circle",
              staticStyle: { color: "white", "font-size": "15px" },
            }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("HOME")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }